module.exports = {
  organization: "organization",
  default: "folloze"
}